import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import './styles.less'
import AttachFilesWidget from '../../widgets/attachfiles/AttachFilesWidget'
import BtnEditAll from '../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { getAttachments } from '../../redux/actions/attachments'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../utils/widget'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import pathname from '../../constants/pathname'
import { ERR_MSG_404_PROJECT_ID } from '../../constants/msgText'
import ViewPreviousVersionButon from '../../components/buttons/viewPreviousVersionButon/ViewPreviousVersionButon'
import { Panel } from 'rsuite'

export default function AttachFilesView() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()
  const [error, setError] = useState()
  
  // 🚩 State สำหรับควบคุมโหมดเปรียบเทียบเวอร์ชัน
  const [isViewPrevious, setIsViewPrevious] = useState(false)
  const [schemaPrevious, setSchemaPrevious] = useState()

  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameForward: `${pathname.proposal.granteeProperty}`,
  }

  useEffect(() => {
    if (projectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAttachments(projectId)
      setSchema(_schema)
      setIsEditWidget({
        attachment: _schema.forms?.attachment?.attachFiles?.value.length > 0 ? false : true,
      })
      setShowEditAll(!_schema.forms?.attachment?.disabled)
    } catch (e) {
      console.error('e', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  // 🚩 ปรับ Logic การดึงข้อมูลก่อนหน้า ให้เหมือน ProjectTypeInfo
  const handleGetSchemaPrevious = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      if (isViewPrevious) {
        setIsViewPrevious(false)
        doneLoading()
        setIsLoading(false)
        return
      }
      if (schemaPrevious) {
        setIsViewPrevious(true)
        doneLoading()
        setIsLoading(false)
        return
      }
      const _schema = await getAttachments(id)
      setSchemaPrevious(_schema)
      setIsViewPrevious(true)
    } catch (e) {
      console.error('e', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  // 🚩 ก้อนที่ 1: จับข้อมูล "เวอร์ชันปัจจุบัน" มัดรวมไว้ในตัวแปรนี้ จะได้ไม่ต้องเขียนโค้ดซ้ำ 2 รอบ
  const renderCurrentVersion = (
    <div className="top">
      {schema?.forms?.attachment && (
        <>
          <AttachFilesWidget
            showCommandButton={!schema.forms.attachment.disabled}
            isEdit={isEditWidget.attachment}
            onChangeIsEdit={(_isEdit) =>
              handleOnChangeIsEdit('attachment', _isEdit, setIsEditWidget)
            }
            schema={schema.forms.attachment}
            loadMenu={true}
          />
          <br />
        </>
      )}
    </div>
  )

  return (
    <SidebarProposal statusDefault={1}>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ViewPreviousVersionButon 
        handleGetSchemaPrevious={handleGetSchemaPrevious} 
        isViewPrevious={isViewPrevious}
      />

      {showEditAll && (
        <BtnEditAll
          onClickEditAll={getIsEditAll(isEditWidget)}
          routing={buttonRoute}
          setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
          editWidget={isEditWidget}
          forms={schema?.forms}
        />
      )}

      <div className="wrapper">
        {/* ==============================================
            ส่วนที่ 1: แสดงข้อมูลปัจจุบัน (สลับมี/ไม่มี Panel)
            ============================================== */}
        <div style={!isViewPrevious ? { width: '100%' } : {}}>
          {isViewPrevious ? (
            <Panel
              collapsible
              defaultExpanded
              shaded
              bordered
              bodyFill
              header={'version ปัจจุบัน'}
              style={{ maxHeight: '550px', overflowY: 'auto', width: '100%' }}
            >
              {renderCurrentVersion}
            </Panel>
          ) : (
            renderCurrentVersion
          )}
        </div>

        {isViewPrevious && schemaPrevious && (
          <>
            <div className="line" />
            <div>
              <Panel
                collapsible
                defaultExpanded
                shaded
                bordered
                bodyFill
                header={'version ก่อนหน้า'}
                style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', backgroundColor: '#e4e4ed'  }}
              >
                <div className="bottom">
                  {schemaPrevious?.forms?.attachment && (
                    <>
                      <AttachFilesWidget
                        showCommandButton={false}
                        isEdit={false}
                        schema={schemaPrevious.forms.attachment}
                        loadMenu={true}
                      />
                      <br />
                    </>
                  )}
                </div>
              </Panel>
            </div>
            <br />
            <br />
          </>
        )}
      </div>
    </SidebarProposal>
  )
}
